import {ChangeDetectorRef, Component} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Compbaser} from "../../../components/compbaser/compbases";
import {TranslocoService} from "@ngneat/transloco";
import {timeout} from "../../../decorators/timeout";
import {LocalStoreService} from "../../../services/local-store.service";
import {fadeTransition} from 'libs/basicTransition';
import * as Highcharts from 'highcharts';
import moment from 'moment';

@Component({
    selector: 'app-usage-avg',
    templateUrl: './usage-avg.component.html',
    styleUrls: ['./usage-avg.component.scss'],
    animations: [fadeTransition]
})
export class UsageAvgComponent extends Compbaser {
    _options;
    _chart: any;
    _ready = false;
    months;
    week1 = [];
    week2 = [];
    week3 = [];
    week4 = [];
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;
    chartLabel;

    constructor(private _http: HttpClient, private cd: ChangeDetectorRef, private translocoService: TranslocoService, private localStoreService: LocalStoreService) {
        super();
        let userData: Array<number> = this.getLocalStorage();
        const now = moment.now();
        userData.push(now);
        userData = this.setUserIntoStorage(userData);
        this.initData(userData);
        this.initGrapha();
    }

    initData(i_data: Array<number>) {
        const months = [];
        const monthsData = {};
        i_data.forEach((v) => {
            const date = moment(v).format('MMM,D').split(',');
            const month: any = date[0];
            const day: any = date[1];
            months.push(month);
            if (!monthsData[month]) {
                monthsData[month] = {};
                monthsData[month]['week1'] = 0;
                monthsData[month]['week2'] = 0;
                monthsData[month]['week3'] = 0;
                monthsData[month]['week4'] = 0;
            }
            if (day < 8) {
                monthsData[month]['week1'] = monthsData[month]['week1'] + 1;
            } else if (day < 15) {
                monthsData[month]['week2'] = monthsData[month]['week2'] + 1;
            } else if (day < 22) {
                monthsData[month]['week3'] = monthsData[month]['week3'] + 1;
            } else {
                monthsData[month]['week4'] = monthsData[month]['week4'] + 1;
            }
        });
        this.months = months.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
        Object.keys(monthsData).forEach((currentMonth, v) => {
            this.week1.push(monthsData[currentMonth]['week1']);
            this.week2.push(monthsData[currentMonth]['week2']);
            this.week3.push(monthsData[currentMonth]['week3']);
            this.week4.push(monthsData[currentMonth]['week4']);
        });
    }

    onSelect(event) {
        console.log(event);
    }

    logChartInstance(chart: Highcharts.Chart) {
        this._chart = chart;
    }

    chartCallback = (chart) => {
        setTimeout(() => {
            if (!chart || !chart.callback || chart.callback.length == 0) return;
            chart.reflow();
        }, 1);
    };

    private setUserIntoStorage(model): Array<number> {
        model = model.splice(-1000); // don't allow for more 1000 entries
        this.localStoreService.setItem('IUserWork', model);
        return model;
    }

    private getLocalStorage(): Array<number> {
        const v = this.localStoreService.getItem('IUserWork');
        if (!v) return [];
        return v;
    }

    @timeout(1000)
    initGrapha() {
        this.chartLabel = this.translocoService.translate('general.studioUsage', {}, this.translocoService.getActiveLang());
        this._options = {
            chart: {
                renderTo: 'chartContainer',
                reflow: true,
                type: 'column',
                borderColor: 'black',
                borderWidth: 0
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: '100%'
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        },
                        yAxis: {
                            labels: {
                                align: 'left',
                                x: 0,
                                y: -5
                            },
                            title: {
                                text: null
                            }
                        },
                        subtitle: {
                            text: null
                        },
                        credits: {
                            enabled: false
                        }
                    }
                }]
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: this.months,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: this.chartLabel
                }
            },
            tooltip: {
                enabled: false
            },
            // tooltip: {
            //     headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
            //     pointFormat: `<tr><td style="color:  {series.color};padding:0">{series.name}: </td><td style="padding:0; color:  {series.color}"><b><span style="color:  {series.color}">{point.y:.1f} </span></b></td></tr>`,
            //     footerFormat: '</table>',
            //     shared: true,
            //     useHTML: true
            // },
            // tooltip: {
            //     headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
            //     pointFormat: `<tr><td style="color: var(--text-color1);padding:0">{series.name}: </td><td style="padding:0; color: var(--text-color1)"><b><span style="color: var(--text-color1)">{point.y:.1f} </span></b></td></tr>`,
            //     footerFormat: '</table>',
            //     shared: true,
            //     useHTML: true
            // },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: 'week 1',
                data: this.week1

            }, {
                name: 'week 2',
                data: this.week2,
                color: 'yellow'

            }, {
                name: 'week 3',
                data: this.week3,
                color: 'pink'

            }, {
                name: 'week 4',
                data: this.week4,
                color: 'orange'

            }],
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
                shadow: false
            }
        };
        this.chartOptions = this._options;
        setTimeout(() => {
            this._ready = true;
        }, 6);
    }
}

